import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LDFlag } from '@core/models/user-profile.model';
import { UserStoreService } from '@core/services/user-store/user-store.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewDefectReportsRedirectGuard implements CanActivate {
  constructor(
    private userService: UserStoreService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userService.isAuthenticated$.pipe(
      filter((isAuthenticated) => isAuthenticated),
      take(1),
      map(() => {
        const canAccessNewDefectReports = this.userService.getLDFlagValue(LDFlag.DEFECT_REPORTS_NEW);

        if (canAccessNewDefectReports) {
          return true;
        }

        return this.getNewToLegacyRedirect(route);
      })
    );
  }

  private getNewToLegacyRedirect(route: ActivatedRouteSnapshot): UrlTree {
    const pageRoute = route.firstChild;
    const tabRoute = pageRoute?.firstChild;
    const tabPath = tabRoute?.routeConfig?.path;

    if (tabPath === 'reviewed') {
      return this.router.createUrlTree(['/defect-reports']);
    }

    const equipmentRef = route.queryParamMap.get('createForEquipment');
    if (equipmentRef) {
      return this.router.createUrlTree(['/defect-reports', 'create', equipmentRef]);
    }

    const defectRef = route.queryParamMap.get('defectRef');
    if (defectRef) {
      return this.router.createUrlTree(['/defect-reports', defectRef]);
    }

    return this.router.createUrlTree(['/defect-reports']);
  }
}
